// src/components/Constant/EducationalBackgroundOptions.js

export const educationalBackgroundOptions = [
  {
    category: "Technical & Engineering",
    options: [
      "B.Tech in Computer Science",
      "B.Tech in Information Technology",
      "B.Tech in Electronics & Communication",
      "B.E. in Mechanical Engineering",
      "M.Tech in Artificial Intelligence",
      "M.Tech in Data Science",
      "M.E. in Electrical Engineering",
      "Ph.D. in Computer Science",
      "B.Sc in Information Technology",
      "M.Sc in Computer Applications",
    ],
  },
  {
    category: "Business & Management",
    options: [
      "BBA in Business Administration",
      "MBA in Marketing",
      "MBA in Finance",
      "MBA in Human Resource Management",
      "PGDM in Digital Marketing",
      "PGPM in Business Analytics",
      "Ph.D. in Management",
    ],
  },
  {
    category: "Commerce & Economics",
    options: [
      "B.Com in Accounting & Finance",
      "M.Com in Taxation",
      "B.A. in Economics",
      "MBA in Economics & Policy",
      "Chartered Accountant (CA)",
    ],
  },
  {
    category: "Design & Creative",
    options: [
      "B.Des in Communication Design",
      "B.Des in UI/UX Design",
      "BFA in Applied Arts",
      "MFA in Animation",
      "Diploma in Graphic Design",
      "Certificate in Motion Graphics",
    ],
  },
  {
    category: "Education & Languages",
    options: [
      "B.Ed. (Bachelor of Education)",
      "M.Ed. (Master of Education)",
      "B.A. in English Literature",
      "M.A. in Linguistics",
      "M.A. in Education Technology",
      "B.A. in Psychology",
      "M.A. in Counseling",
    ],
  },
  {
    category: "Certifications & Diplomas",
    options: [
      "Full Stack Web Development – Coursera",
      "Java Programming Certification – Oracle",
      "Python for Everybody – University of Michigan",
      "Data Structures & Algorithms – NPTEL",
      "Google Android Developer Certification",
      "IBM Data Science Professional Certificate",
      "Machine Learning – Stanford University",
      "TensorFlow Developer Certificate",
      "AWS Certified Solutions Architect",
      "Azure Fundamentals – Microsoft",
      "Google Cloud Professional Data Engineer",
      "Certified Kubernetes Administrator (CKA)",
      "Google UX Design Certificate",
      "Adobe Certified Expert – Photoshop",
      "Figma Masterclass – Udemy",
      "CEH – Certified Ethical Hacker",
      "CompTIA Security+",
      "Offensive Security Certified Professional (OSCP)",
    ],
  },
  {
    category: "Self-Taught or Alternative Paths",
    options: [
      "Self-Taught Programmer",
      "Bootcamp Graduate – Full Stack Development",
      "Freelance UI Designer (10+ Projects)",
      "Online Educator – Udemy/Coursera",
      "Experienced Instructor (100+ hours taught)",
    ],
  },
];
